import { Controller } from '@hotwired/stimulus'

// "Salvar comprovante (PDF)": abre a impressão do navegador (o CSS de print esconde o resto).
export default class extends Controller {
  imprimir() { window.print() }
}
